import * as React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import Navbar from "./navbar"
import Footer from "./footer"
import "../styles/main.scss"

const Layout = ({ children, headerColor, footerColor }) => {
  if (
    typeof window !== "undefined" &&
    process.env.NODE_ENV === "production" &&
    window.location.protocol === "http:"
  ) {
    window.location.href = window.location.href.replace(/^http:/, "https:")
  }

  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <div className="container-fluid p-0">
      <Navbar
        siteTitle={data.site.siteMetadata?.title || `Title`}
        headerColor={headerColor}
      />
      <main>{children}</main>
      <Footer
        siteTitle={data.site.siteMetadata?.title || `Title`}
        footerColor={footerColor}
      />
    </div>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  headerColor: PropTypes.string,
  footerColor: PropTypes.string,
}

Layout.defaultProps = {
  headerColor: "#F2F8FC",
  footerColor: "#fff",
}

export default Layout
